import { z } from 'zod';
import { IsoDateStringSchema, UuidV7Schema } from './common.js';

/**
 * Trace RGPD des consentements acceptés par le prospect au moment de la
 * création du lead. Une entrée par checkbox cochée. Source de vérité côté
 * back : table `lead_consents`, persistée à la création du lead et jamais
 * mutée par la suite (preuve légale).
 */
export const LeadConsentSchema = z.object({
  id: UuidV7Schema,
  leadId: UuidV7Schema,
  position: z.number().int().min(0).max(20),
  label: z.string().min(1).max(500),
  acceptedAt: IsoDateStringSchema,
  createdAt: IsoDateStringSchema,
});
export type LeadConsent = z.infer<typeof LeadConsentSchema>;

/**
 * Entrée envoyée par le client au moment de `POST /leads`. La position
 * est implicite (index dans le tableau) ; le backend la matérialise.
 */
export const LeadConsentInputSchema = z.object({
  label: z.string().min(1).max(500),
  acceptedAt: IsoDateStringSchema,
});
export type LeadConsentInput = z.infer<typeof LeadConsentInputSchema>;
